/* @flow strict */

import * as React from 'react';

export const EventDetailContainerContext = React.createContext({});
